export default class ActionRequiredError extends Error {
  constructor (paymentIntentClientSecret) {
    super()

    this.name = 'StripeActionRequiredError'
    this.message = `Extra action is required to proceed with the payment.`
    this.paymentIntentClientSecret = paymentIntentClientSecret
  }
}
